export default __webpack_public_path__ + "static/media/spade.f39fb8f1.svg";